export const UTILITY_PROP_NAMES = Object.freeze([
    'align',
    'alignContent',
    'alignItems',
    'alignSelf',
    'area',
    'areas',
    'autoColumns',
    'autoRows',
    'background',
    'backgroundColor',
    'basis',
    'bg',
    'border',
    'borderBottom',
    'borderBottomColor',
    'borderBottomLeftRadius',
    'borderBottomRadius',
    'borderBottomRightRadius',
    'borderBottomStyle',
    'borderBottomWidth',
    'borderColor',
    'borderEnd',
    'borderEndColor',
    'borderEndEndRadius',
    'borderEndStartRadius',
    'borderEndStyle',
    'borderEndWidth',
    'borderInlineEndRadius',
    'borderInlineStartRadius',
    'borderLeft',
    'borderLeftColor',
    'borderLeftRadius',
    'borderLeftStyle',
    'borderLeftWidth',
    'borderRadius',
    'borderRight',
    'borderRightColor',
    'borderRightRadius',
    'borderRightStyle',
    'borderRightWidth',
    'borderStart',
    'borderStartColor',
    'borderStartEndRadius',
    'borderStartStartRadius',
    'borderStartStyle',
    'borderStartWidth',
    'borderStyle',
    'borderTop',
    'borderTopColor',
    'borderTopLeftRadius',
    'borderTopRadius',
    'borderTopRightRadius',
    'borderTopStyle',
    'borderTopWidth',
    'borderWidth',
    'borderX',
    'borderXColor',
    'borderXWidth',
    'borderY',
    'borderYColor',
    'borderYWidth',
    'boxShadow',
    'boxSizing',
    'colEnd',
    'colSpan',
    'colStart',
    'color',
    'cols',
    'columns',
    'cursor',
    'direction',
    'display',
    'divideColor',
    'divideStyle',
    'divideX',
    'divideY',
    'flow',
    'gap',
    'gapX',
    'gapY',
    'grow',
    'h',
    'height',
    'hideBelow',
    'hideFrom',
    'inline',
    'justify',
    'justifyContent',
    'justifyItems',
    'justifySelf',
    'm',
    'margin',
    'marginBottom',
    'marginEnd',
    'marginLeft',
    'marginRight',
    'marginStart',
    'marginTop',
    'marginX',
    'marginY',
    'maxH',
    'maxHeight',
    'maxLines',
    'maxW',
    'maxWidth',
    'mb',
    'me',
    'minH',
    'minHeight',
    'minW',
    'minWidth',
    'ml',
    'mr',
    'ms',
    'mt',
    'mx',
    'my',
    'outlineColor',
    'p',
    'padding',
    'paddingBottom',
    'paddingEnd',
    'paddingLeft',
    'paddingRight',
    'paddingStart',
    'paddingTop',
    'paddingX',
    'paddingY',
    'pb',
    'pe',
    'pl',
    'placeContent',
    'placeItems',
    'placeSelf',
    'pr',
    'ps',
    'pt',
    'px',
    'py',
    'rounded',
    'roundedBottom',
    'roundedBottomLeft',
    'roundedBottomRight',
    'roundedEnd',
    'roundedEndEnd',
    'roundedEndStart',
    'roundedLeft',
    'roundedRight',
    'roundedStart',
    'roundedStartEnd',
    'roundedStartStart',
    'roundedTop',
    'roundedTopLeft',
    'roundedTopRight',
    'rowEnd',
    'rowSpan',
    'rowStart',
    'rows',
    'shadow',
    'shrink',
    'spaceX',
    'spaceY',
    'textAlign',
    'textStyle',
    'translateX',
    'translateY',
    'truncate',
    'uppercase',
    'w',
    'width',
    'wrap',
    'zIndex',
]);
const UTILITY_PROP_NAME_SET = new Set(UTILITY_PROP_NAMES);
export function isUtilityPropName(propName) {
    return UTILITY_PROP_NAME_SET.has(propName);
}
//# sourceMappingURL=utility-prop-names.js.map